import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BASE_URL_ADMIN } from "../constants/constant";
import axios from "axios";
import Sidebar from "../sidebar/sidebar";
import TopBar from "../Navbar/Pages/Topbar";
import { validateImageFile } from "../validation";
import "../css/package_update.css";

const Package_update = () => {
  const { package_id } = useParams();
  const navigate = useNavigate();
  const isEdit = Boolean(package_id);

  const [formData, setFormData] = useState({
    packageName: "",
    seatprice: "",
    source: "",
    destination: "",
    departure: "",
    arrival: "",
    advancepayment: "",
    packageprice: "",
    bustype: "",
    packageimage: null,
    entryPoints: [""],
  });

  const [busTypes, setBusTypes] = useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 768);
  const [adminId, setAdminId] = useState(null);

  useEffect(() => {
    const storedAdminId = sessionStorage.getItem("admin_id");
    setAdminId(storedAdminId);
  }, []);

  useEffect(() => {
    if (isEdit) {
      axios
        .post(`${BASE_URL_ADMIN}get_single_package.php`, { package_id })
        .then((res) => {
          const data = res.data.data;
          if (!data) {
            alert("Package not found");
            navigate("/admindashboard");
            return;
          }
          setFormData({
            packageName: data.Packagename || "",
            seatprice: data.seatprices || "",
            source: data.source || "",
            destination: data.destination || "",
            departure: data.departure_time || "",
            arrival: data.arrival_time || "",
            advancepayment: data.advanve_payment || "",
            packageprice: data.package_price || "",
            bustype: String(data.bustype_id || ""),
            packageimage: data.package_image || "",
            entryPoints: JSON.parse(data.entryPoints || "[]"),
          });
        })
        .catch((err) => console.error("Package load error:", err));
    }
  }, [package_id, isEdit, navigate]);

  useEffect(() => {
    axios
      .post(`${BASE_URL_ADMIN}bus_type_fetching.php`)
      .then((res) => {
        if (res.data.success) {
          setBusTypes(res.data.bus_types);
        }
      })
      .catch((err) => console.error("Bus type fetch error:", err));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && !validateImageFile(file)) {
      alert("Please upload a valid image file (JPEG, JPG, PNG, GIF).");
      e.target.value = "";
      return;
    }
    setFormData((prev) => ({ ...prev, packageimage: file }));
  };

  const handleEntryPointChange = (index, value) => {
    const updated = [...formData.entryPoints];
    updated[index] = value;
    setFormData((prev) => ({ ...prev, entryPoints: updated }));
  };

  const addEntryPoint = () =>
    setFormData((prev) => ({
      ...prev,
      entryPoints: [...prev.entryPoints, ""],
    }));

  const removeEntryPoint = (index) => {
    const updated = formData.entryPoints.filter((_, i) => i !== index);
    setFormData((prev) => ({ ...prev, entryPoints: updated }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const formDataToSend = new FormData();
    Object.keys(formData).forEach((key) => {
      if (key === "entryPoints") {
        formDataToSend.append(key, JSON.stringify(formData[key]));
      } else if (key === "packageimage") {
        if (formData[key]) {
          formDataToSend.append(key, formData[key]);
        }
      } else {
        formDataToSend.append(key, formData[key]);
      }
    });

    if (isEdit) {
      formDataToSend.append("package_id", package_id);
      formDataToSend.append("updated_by", adminId);
    } else {
      formDataToSend.append("created_by", adminId);
    }

    const endpoint = isEdit
      ? `${BASE_URL_ADMIN}update_package.php`
      : `${BASE_URL_ADMIN}packageadding.php`;

    axios
      .post(endpoint, formDataToSend, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        if (res.data.success) {
          alert(`Package ${isEdit ? "updated" : "added"} successfully!`);
          navigate("/admindashboard");
        } else {
          alert(`Error: ${res.data.message}`);
        }
      })
      .catch((err) => {
        console.error(`${isEdit ? "Update" : "Add"} error:`, err);
        alert("Something went wrong.");
      });
  };

  return (
    <div className="container-fluid">
      <TopBar />
      <div className="row">
        <Sidebar onToggle={() => setIsSidebarOpen(!isSidebarOpen)} />
        <div
          className={`col ${
            !isSidebarOpen ? "col-12" : "col-md-9 offset-md-2"
          } p-4`}
        >
          <h2 className="text-center mb-4">Tour Package Update</h2>
          <div className="update_package_form">
            <form onSubmit={handleSubmit} className="package-form">
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="packageName" className="form-label">
                    Package Name
                  </label>
                  <input
                    type="text"
                    id="packageName"
                    name="packageName"
                    className="form-control"
                    value={formData.packageName}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-6">
                  <label htmlFor="source" className="form-label">
                    Source
                  </label>
                  <input
                    type="text"
                    id="source"
                    name="source"
                    className="form-control"
                    value={formData.source}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="destination" className="form-label">
                    Destination
                  </label>
                  <input
                    type="text"
                    id="destination"
                    name="destination"
                    className="form-control"
                    value={formData.destination}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-6">
                  <label htmlFor="seatprice" className="form-label">
                    Seat Price
                  </label>
                  <input
                    type="text"
                    id="seatprice"
                    name="seatprice"
                    className="form-control"
                    value={formData.seatprice}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label">Entry Points</label>
                {formData.entryPoints.map((entryPoint, index) => (
                  <div key={index} className="d-flex mb-2">
                    <input
                      type="text"
                      className="form-control"
                      value={entryPoint}
                      onChange={(e) =>
                        handleEntryPointChange(index, e.target.value)
                      }
                      placeholder={`Entry Point ${index + 1}`}
                    />
                    <button
                      type="button"
                      style={{ backgroundColor: "#f67b1c",borderColor:"#f67b1c" ,color: "white" }}
                      className="btn btn-danger ms-2"
                      onClick={() => removeEntryPoint(index)}
                    >
                      &times;
                    </button>
                  </div>
                ))}
                <button
                  type="button"
                  className="btn btn-secondary entry_points"
                  style={{ backgroundColor: "#f67b1c",borderColor:"#f67b1c" ,color: "white" }}
                  onClick={addEntryPoint}
                >
                  + Add Entry Point
                </button>
              </div>

              {/* Departure, Arrival, Advance Payment */}
              <div className="row mb-3">
                <div className="col-md-4">
                  <label htmlFor="departure" className="form-label">
                    Departure Time
                  </label>
                  <input
                    type="datetime-local"
                    id="departure"
                    name="departure"
                    className="form-control"
                    value={formData.departure}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-4">
                  <label htmlFor="arrival" className="form-label">
                    Arrival Time
                  </label>
                  <input
                    type="datetime-local"
                    id="arrival"
                    name="arrival"
                    className="form-control"
                    value={formData.arrival}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-4">
                  <label htmlFor="advancepayment" className="form-label">
                    Advance Payment
                  </label>
                  <input
                    type="text"
                    id="advancepayment"
                    name="advancepayment"
                    className="form-control"
                    value={formData.advancepayment}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* Package Price, Bus Type, Image Upload */}
              <div className="row mb-3">
                <div className="col-md-4">
                  <label htmlFor="packageprice" className="form-label">
                    Package Price
                  </label>
                  <input
                    type="text"
                    id="packageprice"
                    name="packageprice"
                    className="form-control"
                    value={formData.packageprice}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-4">
                  <label htmlFor="bustype" className="form-label">
                    Bus Type
                  </label>
                  <select
                    id="bustype"
                    name="bustype"
                    className="form-select"
                    value={formData.bustype}
                    onChange={handleChange}
                  >
                    <option value="" disabled>
                      Select a bus type
                    </option>
                    {busTypes.map((bus) => (
                      <option key={String(bus.id)} value={String(bus.id)}>
                        {bus.layout}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-4">
                  <label htmlFor="packageimage" className="form-label">
                    Upload New Image
                  </label>
                  <input
                    type="file"
                    id="packageimage"
                    name="packageimage"
                    accept="image/*"
                    className="form-control"
                    onChange={handleFileChange}
                  />
                </div>
              </div>

              <div className="row mt-3">
                <div className="col text-center">
                  <button type="submit" className="update-details-button">
                    {isEdit ? "Update" : "Submit"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Package_update;
